import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';

import * as XBBCODE from 'xbbcode-parser/xbbcode';
import 'xbbcode-parser/xbbcode.css';

function duckPunchModifiedUrlHandling() {
    XBBCODE.tags().url.openTag = (params, content, zomg) => {
        const myUrl = !params ? content.replace(/<.*?>/g, '') : params.substr(1);

        const target = (myUrl.search(/mailto/i) === 0) ? '' : ' target="_blank"';

        return '<a href="' + myUrl + '"' + target + '>';
    }
}

duckPunchModifiedUrlHandling();

export class FormattedTextControl extends Control {
    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container');

        this.render(this.config['content.Markup']);

        this.applyTooltip(this.$element);

        this.subscriptions = this.processBindings(this.config);

        this.initialize();
    }

    private render(markup: string) {
        var result = XBBCODE.process({
            text: markup || '',
            removeMisalignedTags: false,
            addInLineBreaks: true
        });

        this.$element.empty().append(result.html);
    }

    'content.Markup'(value: string) {
        this.render(value);
    }

    focus() { }
}

registerBinding('formattedtextcontrol', FormattedTextControl);